function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { Link } from '@applyboard/ui-components';
import { chartColors } from "./charts/utils/global";
export var ALL_STAFF = 'All staff';
export var DEFAULT_LINE_STROKE_COLOR = 'blue-12';
export var getStaffDropdownOptions = function getStaffDropdownOptions(staffs, staffData) {
  var options = [];
  if (staffData) {
    staffs === null || staffs === void 0 || staffs.forEach(function (staffId) {
      var rpStaff = staffData.find(function (r) {
        return r.id === staffId;
      });
      if (rpStaff && !(rpStaff !== null && rpStaff !== void 0 && rpStaff.isOwner)) options.push({
        label: rpStaff.firstName && rpStaff.lastName ? "".concat(rpStaff.firstName, " ").concat(rpStaff.lastName) : "".concat(rpStaff.email),
        value: staffId
      });
    });
    options.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }
  return options;
};
export var getStaffName = function getStaffName(staffId, staffData) {
  var rpStaff = staffData.find(function (staff) {
    return staff.id === staffId.toString();
  });
  if (rpStaff) {
    return rpStaff.firstName && rpStaff.lastName ? "".concat(rpStaff.firstName, " ").concat(rpStaff.lastName) : "".concat(rpStaff.email);
  }
  return 'All Staff';
};
export var getYearDropdownOptions = function getYearDropdownOptions(years) {
  var options = [];
  years = years.slice().sort().reverse();
  years.forEach(function (year) {
    return options.push({
      label: year,
      value: year
    });
  });
  return options;
};
export var getTypeDropdownOptions = function getTypeDropdownOptions(types) {
  var options = [];
  types.forEach(function (type) {
    return options.push({
      label: type,
      value: type
    });
  });
  return options;
};
export var getCountryDropdownOptions = function getCountryDropdownOptions(countries) {
  var options = [];
  options.push({
    label: 'All countries',
    value: ''
  });
  countries.forEach(function (country) {
    return options.push({
      label: country,
      value: country
    });
  });
  return options;
};
export var getCurrencyDropdownOptions = function getCurrencyDropdownOptions(currencies) {
  var options = [];
  var sortedCurrencies = currencies.map(function (currency) {
    return currency.toUpperCase();
  }).sort();
  sortedCurrencies.forEach(function (currency) {
    return options.push({
      label: currency,
      value: currency
    });
  });
  return options;
};
export var StaffAccountLink = function StaffAccountLink() {
  return /*#__PURE__*/React.createElement(Link, {
    href: "/profile#tab-manage-staff",
    underline: "none",
    target: "_blank",
    style: {
      padding: '8px 0px 8px 8px',
      fontFamily: 'Open Sans',
      fontSize: '16px',
      fontWeight: 400,
      letterSpacing: '0px',
      lineHeight: '24px'
    }
  }, "+ Add New Staff Account");
};
export var updateAppliedFilters = function updateAppliedFilters(currentFilters, updatedKey, newValue) {
  var updatedFilters = currentFilters.map(function (item) {
    if (item.label === updatedKey) return _objectSpread(_objectSpread({}, item), {}, {
      value: newValue
    });
    return item;
  });
  return updatedFilters;
};
export var getChartLineStrokeColor = function getChartLineStrokeColor(labelArrays, label) {
  var labelIndex = _toConsumableArray(labelArrays).sort().findIndex(function (value) {
    return value.trim().toLowerCase() === label.trim().toLowerCase();
  });
  if (labelIndex === -1) {
    return DEFAULT_LINE_STROKE_COLOR;
  }
  var colorsArray = Object.keys(chartColors);
  var labelColor = colorsArray[labelIndex % colorsArray.length];
  var colorShadeArray = Object.keys(chartColors[labelColor.toUpperCase()]);
  var colorShadeArrayMidPoint = Math.floor((colorShadeArray.length - 1) / 2);
  var labelShade = colorShadeArray[colorShadeArrayMidPoint];
  return "".concat(labelColor.toLowerCase(), "-").concat(labelShade);
};
export var getFullMonth = function getFullMonth(month) {
  switch (month) {
    case 'Jan':
      return 'January';
    case 'Feb':
      return 'February';
    case 'Mar':
      return 'March';
    case 'Apr':
      return 'April';
    case 'Jun':
      return 'June';
    case 'Jul':
      return 'July';
    case 'Aug':
      return 'August';
    case 'Sep':
      return 'September';
    case 'Oct':
      return 'October';
    case 'Nov':
      return 'November';
    case 'Dec':
      return 'December';
    default:
      return month;
  }
};